export default __webpack_public_path__ + "static/media/am.6a55c9ad.svg";